import React from 'react';
import ProcessStep from '../../../core/ProcessStep';
import Shimmer from '../../../core/Shimmer/Shimmer';

// Renders the real core/ProcessStep rows with shimmer placeholders for the title (14px/1.4
// line box → 20px), the 38px picker (36 + border) and the "Done!" label, so badges, connector and
// spacing are byte-identical to the loaded panel and nothing shifts when the data lands.
const ApprovalReviewersSkeleton = ({ steps = 1 }) => (
    <ProcessStep
        steps={Array.from({ length: Math.max(1, steps) }, (_, index) => ({
            id: `skeleton-${index}`,
            title: <Shimmer width="120px" height={20} radius={4} />,
            content: <Shimmer width="100%" height={38} radius={6} />,
        }))}
        doneLabel={<Shimmer width="60px" height={20} radius={4} />}
    />
);

export default React.memo(ApprovalReviewersSkeleton);
